import apiService from 'services/api.service';
import { useMutation, useQueryClient } from 'react-query';


export default function useUpdateAiResult(resultId) {
  const queryClient = useQueryClient();

  return useMutation(
    (updatedResult) => apiService.post(`/transactions/result/${resultId}`, updatedResult),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['transaction.ai.result', resultId]);
      },
    },
  );
}
